export default "__VITE_ASSET__BQScaA0L__"